import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import SimpleThread from '../SimpleThread';
import { useFlag } from '../../../redux/flags/hooks';
import s from './CardLayoutThread.scss';
var CardLayoutThread = function (props) {
    var isRedesignB = useFlag('comment_redesign_b');
    return (React.createElement(SimpleThread, __assign({}, props, { className: classnames(s['card-layout'], props.className, isRedesignB && s['comment_redesign_b']), commentBoxWrapperClassName: s['commentbox-wrapper'], threadStackClassName: s['thread-stack'], headerClassName: s['header'], scrollableClassName: s['scrollable'], replyIndentModifier: 0 })));
};
CardLayoutThread.displayName = 'CardLayoutThread';
export default CardLayoutThread;
//# sourceMappingURL=CardLayoutThread.js.map